// extracted by mini-css-extract-plugin
export default {"youtube-wrapper":"Youtube_youtube-wrapper__A7XQ-","youtube-video":"Youtube_youtube-video__WiRe8","youtube-title":"Youtube_youtube-title__lTxMb"};